import axios from "axios";

const apiUrl = "https://apiv2-test.boundlessportal.com/";

export const upload = async (id, file, type) => {
  const data = new FormData() ;
  data.append('file', file);
  return await axios.post(apiUrl + "upload/" + id + '/' + type, data);
}

export const createUser = (body) => axios.post(apiUrl + 'users/', body);

export const updateUser = (id, body) => axios.patch(apiUrl + 'users/' + id, body);
